<template>
  <div id="app">
    <!-- 根据设备类型显示不同的页面组件 -->
    <component :is="currentComponent" />
    
    <!-- 调试信息 -->
    <div class="debug-info" v-if="showDebug">
      <p>设备类型: {{ isMobile ? '移动端' : '桌面端' }}</p>
      <p>屏幕宽度: {{ screenWidth }}px</p>
      <p>User Agent: {{ isMobileUA ? '移动设备' : '桌面设备' }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
    // 使用异步组件加载，只有需要的组件才会被加载和执行
    MainH5: () => import('./pages/MainH5.vue'),
    MainWeb: () => import('./pages/MainWeb.vue')
  },
  data() {
    return {
      isMobile: false,
      screenWidth: 0,
      isMobileUA: false,
      showDebug: false // 设为true可显示调试信息
    }
  },
  watch: {
    // 监听 isMobile 的变化 console 出来
    isMobile(newVal) {
      console.log('isMobile', newVal)
    }
  },
  computed: {
    currentComponent() {
      return this.isMobile ? 'MainH5' : 'MainWeb'
    }
  },
  mounted() {
    this.detectDevice()
    this.handleResize()
  },
  methods: {
    // 检测设备类型
    detectDevice() {
      // 检测User Agent
      const userAgent = navigator.userAgent.toLowerCase()
      const mobileKeywords = [
        'android', 'iphone', 'ipad', 'ipod', 'blackberry', 
        'windows phone', 'mobile', 'webos', 'opera mini'
      ]
      this.isMobileUA = mobileKeywords.some(keyword => userAgent.includes(keyword))
      
      // 检测屏幕宽度
      this.screenWidth = window.innerWidth
      const isMobileScreen = this.screenWidth < 768
      
      // 综合判断
      this.isMobile = this.isMobileUA || isMobileScreen
      
      // 设置viewport
      this.setViewport()
    },
    
    // 设置viewport
    setViewport() {
      const viewport = document.querySelector('meta[name="viewport"]')
      if (viewport) {
        if (this.isMobile) {
          viewport.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
        } else {
          viewport.content = 'width=1200, initial-scale=1.0'
        }
      }
    },
    
    // 处理窗口大小变化
    handleResize() {
      let resizeTimer
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer)
        resizeTimer = setTimeout(() => {
          const wasMobile = this.isMobile
          this.detectDevice()
          
          // 如果设备类型改变，可以在这里处理
          if (wasMobile !== this.isMobile) {
            console.log('设备类型改变:', this.isMobile ? '移动端' : '桌面端')
          }
        }, 300)
      })
    }
  }
}
</script>

<style lang="scss">
body, html {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  user-select: none;
}
#app {
  width: 100%;
  height: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

// 调试信息样式
.debug-info {
  position: fixed;
  top: 10px;
  right: 10px;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 10px;
  border-radius: 5px;
  font-size: 12px;
  z-index: 9999;
  
  p {
    margin: 2px 0;
  }
}
</style>
